export default __webpack_public_path__ + "static/media/ic_Students.2409f818.svg";